// Generated by scripts/build-ui-icons.mjs.
export { GlobeHemisphereWest as default } from "../ui/glyphs-4";
